import { LoginWithTaskHandler } from '../../loginWithTask/LoginWithTask';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const loginWithTaskHandler: LoginWithTaskHandler = () => {};
